import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { useState } from 'react'

import ContentfulPreOrderModal from '@src/quince-site-common/src/domains/contentful/ContentfulPreOrder'
import IButton from '@src/quince-site-common/src/icons/iButtton.inline.svg'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import Button from '../button'
import { IconButton } from '../icon-button'
import Modal from '../modal'
import * as productStyles from '../productOfferMessage/productOfferMessage.module.scss'

import styles from './preOrderMessage.module.scss'

interface PreOrderInfoPopupType {
  preOrderModalData?: ContentfulPreOrderModal
  showPopup: boolean
  setShowPopup: (val: boolean) => void
}

interface PreOrderPopupQnAType {
  question: string | null
  answer: string | Document | undefined
}

interface PropType {
  preOrderModalData?: ContentfulPreOrderModal
  preOrderShippingDate?: string
  selectedVariantId?: number
  customMessage?: string
}

function PreOrderPopupQnA({ question, answer }: PreOrderPopupQnAType) {
  return (
    <div className={styles.qnaItemWrapper}>
      <div className={styles.question}>{question}</div>
      <div className={styles.answer}>
        {answer && documentToReactComponents(typeof answer === 'string' ? JSON.parse(answer) : answer)}
      </div>
    </div>
  )
}

function PreOrderInfoPopup({ preOrderModalData, showPopup, setShowPopup }: PreOrderInfoPopupType) {
  function handleBtnClick() {
    handleClose()
  }

  function handleClose() {
    setShowPopup(false)
  }

  return (
    <Modal
      open={showPopup}
      className={styles.preOrderModal}
      modalWrapperClassName={styles.preOrderModalWrapper}
      showCloseButton={true}
      onClose={handleClose}
    >
      <div className={styles.preOrderPopupWrapper}>
        <h2 className={styles.header}>{preOrderModalData?.displayTitle}</h2>
        <div>
          {preOrderModalData?.genericContents.map(data => (
            <PreOrderPopupQnA key={data.id} question={data.title} answer={data.content?.content.raw} />
          ))}
        </div>
        {preOrderModalData?.buttons.map(btn => (
          <Button
            key={btn.id}
            type={btn.type}
            size={btn.size}
            className={styles.gotItBtn}
            round={btn.rounded}
            onClick={handleBtnClick}
          >
            {btn.title}
          </Button>
        ))}
      </div>
    </Modal>
  )
}

function PreOrderMessage({ selectedVariantId, preOrderModalData, preOrderShippingDate, customMessage }: PropType) {
  const [showPopup, setShowPopup] = useState<boolean>(false)

  if (!preOrderModalData) return <></>
  return (
    <div
      className={classNames(
        styles.preOrderMessageWrapper,
        productStyles.offermessage,
        productStyles.offermessage__offerMessageWithMto,
      )}
    >
      <div className={styles.headingWrapper}>
        <h3 className={styles.heading}>READY TO PREORDER</h3>
        <IconButton
          iconSvg={() => <IButton className={styles.infoIcon} height={12} width={12} />}
          className={styles.infoBtn}
          onClick={() => {
            trackEvent(TELEMETRY_EVENT_NAMES.PREORDER_INFO_CLICK, {
              variantId: selectedVariantId,
            })
            if (!preOrderModalData) {
              console.warn('Pre order data is not available')
              return
            }
            setShowPopup(true)
          }}
          ariaLabel="Preorder info"
        />
      </div>
      <div className={styles.content}>
        {customMessage ??
          `This item will be shipped around ${dayjs(preOrderShippingDate).format('MMMM DD')}. Preorder now to get it first.`}
      </div>
      <PreOrderInfoPopup preOrderModalData={preOrderModalData} showPopup={showPopup} setShowPopup={setShowPopup} />
    </div>
  )
}

export default PreOrderMessage
